<template>
  <div class="x-loading-spinner"></div>
</template>

<!-- eslint-disable vue/block-lang -->
<script>
/* eslint-disable vue/component-api-style */
/**
 * An element that spins to indicate a state of loading
 *
 * ```
 * import xLoadingSpinner from '@/components/shared/x-loading-spinner'
 *
 * <x-loading-spinner />
 * ```
 */
export default {
  name: 'XLoadingSpinner',
}
</script>

<style lang="scss" scoped>
@use '@/styles/system/_colors.scss';

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.x-loading-spinner {
  border: 2px solid colors.$Grey20;
  border-top: 2px solid colors.$BaseBlack;
  border-radius: 50%;
  margin: 0 auto 15px;
  width: 25px;
  height: 25px;
  animation: spin 2s linear infinite;
}
</style>
